import React, { useState, useEffect } from 'react';
import KickImage from 'Reuseables/KickImage';
import { Container, Row } from 'react-bootstrap';
import { getCollectionList } from '../../../actions/kafairAction';
import { connect } from 'react-redux';
import SliderLeftHovered from '../../../images/left-black-arrow-3.png';
import SliderRightHovered from '../../../images/right-black-arrow-3.png';
import ProductSlider from './Helpers/ProductSlider';
import styled from 'styled-components';
import ReactLoading from 'react-loading';
interface PreviousSlide {
  className: string;
  style: Object;
  onClick: () => any;
}

const PrevSlide = (props: PreviousSlide) => {
  const { className, style, onClick } = props;
  const LeftArrow = styled.div`
    &::before {
      content: '';
    }
    img {
      width: 40px !important;
      height: 40px !important;
      left: 50px !important;
      position: absolute;
      object-fit: contain;
    }
    @media (max-width: 480px) {
      img {
        width: 30px !important;
        height: 30px !important;
        position: absolute;
        left: -5px;
      }
    }
  `;
  return (
    <LeftArrow
      className={className}
      style={{
        ...style,
        left: '40px !important',
        width: '40px',
        height: '40px',
        display: window.screen.availWidth < 640 ? 'none' : 'block',
      }}
      onClick={onClick}
    >
      <KickImage src={SliderLeftHovered} alt="..." />
    </LeftArrow>
  );
};

interface NextSlide {
  className: string;
  style: Object;
  onClick: () => any;
}

const NextSlide = (props: NextSlide) => {
  const { className, style, onClick } = props;
  const LeftArrow = styled.div`
    &::before {
      content: '';
    }
    img {
      width: 40px !important;
      height: 40px !important;
      object-fit: contain;
      right: -50px;
      position: absolute;
    }
    @media (max-width: 480px) {
      img {
        right: 5px;
        width: 30px !important;
        height: 30px !important;
      }
    }
  `;
  return (
    <LeftArrow
      className={className}
      style={{
        ...style,
        display: window.screen.availWidth < 640 && 'none',
        width: '40px',
        height: '40px',
      }}
      onClick={onClick}
    >
      <KickImage src={SliderRightHovered} alt="..." />
    </LeftArrow>
  );
};

const settings = {
  dots: false,
  infinite: false,
  speed: 500,
  slidesToShow: 4,
  slidesToScroll: 4,
  prevArrow: <PrevSlide />,
  nextArrow: <NextSlide />,
  responsive: [
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ],
};

const CollectionParent = ({
  title,
  slug,
  images,
  category,
  history,
  children,
  getCollectionList,
  isCollectionWithImage,
  noShadow,
  isPreVerified,
}) => {
  const [dataProducts, setDataProducts] = useState([]);
  const [selected, setSelected] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [categoryUrl, setCategoryUrl] = useState('');
  const [collectionId, setCollectionId] = useState(null);

  useEffect(() => {
    const categoryParams =
      category === 'lifestyles'
        ? 'electronics-collectibles'
        : category === 'apparels' || category === 'Apparels'
        ? 'apparel'
        : category === 'handbags'
        ? 'luxury'
        : category;

    setCategoryUrl(categoryParams);
  }, [category]);

  useEffect(() => {
    setIsLoading(true);
    if (children && children.length > 0 && !selected) {
      setSelected(children[0]);
      let payload;

      if (!isPreVerified) {
        payload = {
          category,
          availables: true,
          per_page: 11,
        };
      }

      if (isPreVerified) {
        payload = {
          category,
          availables: true,
          per_page: 11,
          pre_verified: true,
        };
      }

      getCollectionList(category, children[0].slug, payload, children[0].name)
        .then(({ value }) => {
          setCollectionId(value?.data?.id ?? null);
          setDataProducts(value.data.products.data);
        })
        .catch((e) => console.log(e, 'ini error'));

      setTimeout(() => {
        setIsLoading(false);
      }, 2000);
    } else {
      let payload;
      if (!isPreVerified) {
        payload = {
          category,
          availables: true,
          per_page: 11,
        };
      }

      if (isPreVerified) {
        payload = {
          category,
          availables: true,
          per_page: 11,
          pre_verified: true,
        };
      }

      if (selected) {
        getCollectionList(category, selected.slug, payload, selected.name)
          .then(({ value }) => {
            setCollectionId(value?.data?.id ?? null);
            setDataProducts(value.data.products.data);
          })
          .catch((e) => console.log(e, 'ini error'));
      }

      setTimeout(() => {
        setIsLoading(false);
      }, 2000);
    }
  }, [selected, isPreVerified]);

  function handleSelectOption(option: string) {
    setSelected(option);
  }

  return (
    <Container className="container-collection" fluid>
      {title && <h4 className="collection-title">{title}</h4>}
      <div className="collection-options">
        {children &&
          children.length > 0 &&
          children.map((item) => {
            return (
              <div>
                <h5
                  style={{ color: selected == item ? '#159953' : '#a8a8a8' }}
                  onClick={() => handleSelectOption(item)}
                >
                  {item.name}
                </h5>
              </div>
            );
          })}
      </div>
      <div
        style={{
          padding: '20px 0px 0px 0px',
          width: '95%',
          marginLeft: '2.5%',
          marginTop: window.screen.availWidth < 640 ? '0px' : '22px',
          marginBottom: window.screen.availWidth < 640 && '-22.5px',
          height: window.screen.availWidth > 480 && '344px',
          position: 'relative',
        }}
        className="collection-list"
      >
        {isLoading && (
          <div
            style={{
              position: 'absolute',
              inset: window.screen.availWidth < 480 ? '22.5% 45%' : '40% 47.5%',
              translate:
                window.screen.availWidth < 480
                  ? 'transform(-45%, -45%)'
                  : 'transform(-47.5%, -47.5%)',
            }}
          >
            <ReactLoading
              type={'spin'}
              height={50}
              width={50}
              color={'#159953'}
            />
          </div>
        )}
        {!isLoading && dataProducts && dataProducts.length > 0 && (
          <ProductSlider
            dataProducts={dataProducts}
            activeBrowseAll
            chosenOption={selected.name}
            hasShadow={noShadow ? false : true}
            navigateUrl={
              selected && `/${categoryUrl}/collection/${selected.slug}`
            }
            history={history}
            collectionId={collectionId}
          />
        )}
      </div>
    </Container>
  );
};

const mapDispatchToProps = (dispatch) => ({
  getCollectionList: (
    category: string,
    slug: string,
    payload: Object,
    name: string,
  ) => dispatch(getCollectionList(category, slug, payload, name)),
});

export default connect(null, mapDispatchToProps)(CollectionParent);
